export default "__VITE_ASSET__fb909095__"